import {useContext as $j0dCO$useContext, forwardRef as $j0dCO$forwardRef, createRef as $j0dCO$createRef, Component as $j0dCO$Component} from "react";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;


var $4bJ9d = parcelRequire("4bJ9d");
var $f39089b5182d2011$exports = {};

$f39089b5182d2011$exports = (parcelRequire("daZiC")).getBundleURL('j0dCO') + "layout.a0997bea.js";


var $cb7927ce6fa13069$exports = {};

$cb7927ce6fa13069$exports = (parcelRequire("daZiC")).getBundleURL('j0dCO') + "editor.ffa16e31.js";



var $7LSYr = parcelRequire("7LSYr");
const $069376c47959acd8$var$NoteBody = function(props) {
    const { note: note } = props;
    const { setEditingNote: setEditingNote, editingNote: editingNote } = (0, $j0dCO$useContext)((0, $cb7927ce6fa13069$exports.NoteEditorContext));
    const { noteComponent: noteComponent } = (0, $j0dCO$useContext)((0, $f39089b5182d2011$exports.NoteLayoutContext));
    const isEditing = editingNote === note;
    const onClick = ()=>setEditingNote(note);
    const visibility = isEditing ? "hidden" : "inherit";
    return (0, $4bJ9d.default)(noteComponent, {
        visibility: visibility,
        note: note,
        onClick: onClick
    });
};
const $069376c47959acd8$var$NoteMain = (0, $j0dCO$forwardRef)(function(props, ref) {
    const { note: note, offsetY: offsetY, noteHeight: noteHeight } = props;
    const { editingNote: editingNote } = (0, $j0dCO$useContext)((0, $cb7927ce6fa13069$exports.NoteEditorContext));
    if (editingNote === note) return null;
    return (0, $4bJ9d.default)("g.note", [
        (0, $4bJ9d.default)((0, $7LSYr.NoteConnector), {
            note: note
        }),
        (0, $4bJ9d.default)((0, $7LSYr.NotePositioner), {
            offsetY: offsetY,
            noteHeight: noteHeight,
            ref: ref
        }, [
            (0, $4bJ9d.default)($069376c47959acd8$var$NoteBody, {
                note: note
            })
        ])
    ]);
});
class $069376c47959acd8$export$6c88bf799aca3d2b extends (0, $j0dCO$Component) {
    static #_ = this.contextType = (0, $f39089b5182d2011$exports.NoteLayoutContext);
    constructor(props){
        super(props);
        this.updateHeight = this.updateHeight.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.element = (0, $j0dCO$createRef)();
        this.state = {
            height: null
        };
    }
    render() {
        const { style: style, note: note, editHandler: editHandler, editable: editable } = this.props;
        const { scale: scale, nodes: nodes, columnIndex: columnIndex, width: width, paddingLeft: paddingLeft } = this.context;
        const node = nodes[note.id];
        let offsetY = scale(note.height);
        if (node != null) offsetY = node.currentPos;
        const noteHeight = this.state.height || 0;
        return (0, $4bJ9d.default)($069376c47959acd8$var$NoteMain, {
            offsetY: offsetY,
            note: note,
            noteHeight: noteHeight,
            ref: this.element
        });
    }
    updateHeight(prevProps) {
        const node = this.element.current;
        if (node == null) return;
        const height = node.offsetHeight;
        if (height == null) return;
        if (prevProps != null && prevProps.note === this.props.note) return;
        this.setState({
            height: height
        });
        return this.context.registerHeight(this.props.note.id, height);
    }
    componentDidMount() {
        return this.updateHeight.apply(this, arguments);
    }
    componentDidUpdate() {
        return this.updateHeight.apply(this, arguments);
    }
}
const $069376c47959acd8$export$53e4fd4e0e3d986 = function(props) {
    let { inEditMode: editable, ...rest } = props;
    if (editable == null) editable = false;
    const { notes: notes } = (0, $j0dCO$useContext)((0, $f39089b5182d2011$exports.NoteLayoutContext));
    return (0, $4bJ9d.default)("g", notes.map((note)=>{
        return (0, $4bJ9d.default)($069376c47959acd8$export$6c88bf799aca3d2b, {
            key: note.id,
            note: note,
            editable: editable,
            ...rest
        });
    }));
};


//# sourceMappingURL=note.88f0297b.js.map
